export const Footer = () => {
  return (
    <footer
      className="mt-auto"
      style={{
        borderTop: '1px solid var(--hj-hairline-soft)',
        background: 'var(--hj-bg)',
      }}
    >
      <div className="container mx-auto" style={{ padding: '24px 16px', maxWidth: 1200 }}>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
          {/* Logo and Brand */}
          <div className="flex items-center gap-3">
            <img
              src="/brand/wordmark-heyjoe.png"
              alt="Hey Joe"
              className="h-6 w-auto dark:[filter:invert(96%)_sepia(8%)_saturate(280%)_hue-rotate(345deg)_brightness(102%)]"
            />
            <div className="flex flex-col">
              <span
                style={{
                  fontFamily: 'var(--hj-font-script)',
                  fontSize: 18,
                  lineHeight: 1,
                  color: 'var(--hj-ink)',
                  fontWeight: 700,
                }}
              >
                Hey Joe
              </span>
              <span className="mono-label" style={{ color: 'var(--hj-ink-4)' }}>
                Post Production
              </span>
            </div>
          </div>

          <div
            className="hidden md:block"
            style={{ width: 1, height: 36, background: 'var(--hj-hairline-soft)' }}
          />

          <div
            className="flex flex-col items-center md:items-start gap-1"
            style={{ fontSize: 12.5, color: 'var(--hj-ink-3)' }}
          >
            <span>© 2026 North Shore Media, LLC. All rights reserved.</span>
            <div className="flex items-center gap-2">
              <a
                href="https://heyjoe.io/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--hj-ink-2)', textDecoration: 'none' }}
              >
                Privacy
              </a>
              <span style={{ color: 'var(--hj-ink-4)' }}>·</span>
              <a
                href="https://heyjoe.io/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--hj-ink-2)', textDecoration: 'none' }}
              >
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
